import * as React from 'react';

function SvgNewReviews(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M8 0c4.418 0 8 3.226 8 7.207 0 3.98-3.582 7.206-8 7.206a8.764 8.764 0 01-2.857-.473c-.665-.229-4.1 1.7-4.666 1.327-.657-.432 1.574-3.187 1.09-3.776C.582 10.293 0 8.811 0 7.207 0 3.227 3.582 0 8 0zm.293 3.235a.4.4 0 00-.535.181l-1.02 2.066-2.28.331a.4.4 0 00-.221.682l1.65 1.608-.39 2.27a.4.4 0 00.58.422l2.04-1.072 2.038 1.072a.4.4 0 00.58-.421l-.389-2.27 1.65-1.609a.4.4 0 00-.222-.682l-2.28-.331-1.02-2.066a.4.4 0 00-.18-.181z" />
    </svg>
  );
}

export default SvgNewReviews;
